export default __webpack_public_path__ + "resources/icons/d131-9c59.webp";